import { UserProfileType } from "../../redux/auth/authTypes";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import { Button, Divider, IconButton, Typography } from "@mui/material";
import { CloseIcon } from "../../assets/images";
import DrawerLoader from "../commons/DrawerLoader/DrawerLoader";
import React, { useState } from "react";
import TeamDetails from "./TeamDetails";

interface CustomDrawerProps {
  isRight: boolean;
  isOpen: boolean;
  onClose: () => void;
  userProfileAllData: UserProfileType;
  fetching: boolean;
}

const ViewTeamDirectoryDetails: React.FC<CustomDrawerProps> = ({
  isRight,
  isOpen,
  onClose,
  userProfileAllData,

  fetching,
}) => {
  const LocalDrawerContent = (
    <Box
      sx={{
        width: 800,
        padding: 2,
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 2,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "17px" }}>
          <IconButton onClick={onClose}>
            <img src={CloseIcon} alt="Close Icon" />
          </IconButton>

          <Typography variant="h6" sx={{ fontSize: "18px", fontWeight: "500" }}>
            Team Details
          </Typography>
        </div>
      </Box>
      <hr style={{ margin: "0px 0px" }} />
      {fetching && <DrawerLoader />}
      <TeamDetails userProfileAllData={userProfileAllData} />
      <div></div>
    </Box>
  );
  return (
    <div>
      {isRight && (
        <React.Fragment>
          <Drawer anchor="right" open={isOpen} onClose={onClose}>
            {LocalDrawerContent}
          </Drawer>
        </React.Fragment>
      )}
    </div>
  );
};

export default ViewTeamDirectoryDetails;
